import { useEffect, useState } from "react";
import {
  Button,
  TextField,
  Grid,
  Box,
  Paper,
  Typography,
  Checkbox,
  FormControlLabel,
  CardMedia,
  Card,
  CardContent,
  IconButton,
  Autocomplete,
  Switch,
  Chip,
  Popover,
  Dialog,
  DialogContent,
} from "@mui/material";
import { styled } from "@mui/system";
import { useParams } from "react-router-dom";
import styles from "./RestaurantExtraDetails.module.css";
import {
  useLoaderContext,
  useToastContext,
} from "../../../../Context/ToastContext";
import table_2 from "../../../../images/2_table.jpg";
import table_4 from "../../../../images/4_table.jpg";
import table_6 from "../../../../images/6_table.jpg";
import table_8 from "../../../../images/8_table.jpg";
import { Add, Remove } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useUserContext } from "../../../../Context/UserContext";
import {
  DatePicker,
  LocalizationProvider,
  TimePicker,
} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Helmet } from "react-helmet";
import Dropdown from "../../Dropdown/Dropdown1";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  apiDelete,
  apiGet,
  apiPost,
  apiPut,
} from "../../../../utils/ApiManager";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";

const dropdownRestaurantExtraDetails =
  process.env.REACT_APP_FETCH_DROPDOWN_RESTAURANT_EXTRA_DETAILS;
const dropdownExtraDetails = process.env.REACT_APP_FETCH_DROPDOWN_EXTRA_DETAILS;
const handleSubmitExtraDetails =
  process.env.REACT_APP_HANDLE_SUBMIT_EXTRA_DETAILS;
const checkRestaurantDownTimeBookings =
  process.env.REACT_APP_CHECK_RESTAURANT_DOWNTIME_BOOKINGS;
const restaurantDownTime = process.env.REACT_APP_CHECK_RESTAURANT_DOWNTIME;

// Custom styled Paper for form sections
const SectionPaper = styled(Paper)({
  padding: "20px",
  marginBottom: "20px",
  // backgroundColor: "#f5f5f5",
});

const tableTypes = [
  {
    capacity: 2,
    image: table_2,
  },
  {
    capacity: 4,
    image: table_4,
  },
  {
    capacity: 6,
    image: table_6,
  },
  {
    capacity: 8,
    image: table_8,
  },
];

function RestaurantExtraDetails({ next, prev }) {
  const { restaurantID } = useParams();
  const [formData, setFormData] = useState({
    restaurantID: restaurantID,
    cameraStatus: false,
    cameraDetails: "",
    maxOccupancy: "",
    priceForTwo: "",
    // serviceDays: [],
    serviceTimings: {
      Monday: { openingTime: "", closingTime: "", disabled: false },
      Tuesday: { openingTime: "", closingTime: "", disabled: false },
      Wednesday: { openingTime: "", closingTime: "", disabled: false },
      Thursday: { openingTime: "", closingTime: "", disabled: false },
      Friday: { openingTime: "", closingTime: "", disabled: false },
      Saturday: { openingTime: "", closingTime: "", disabled: false },
      Sunday: { openingTime: "", closingTime: "", disabled: false },
    },
    startDate: null,
    endDate: null,
    downtimeReason: "",
    cancellationPolicy: false,
    cancellationPolicyDetails: "",
    tableEntries: [],
    cancellationBeforeHours: "",
    amenities: [],
    bookingBeforeHours: 0,
  });
  const [maxOccupancy, setMaxOccupancy] = useState(0);
  const [applyToAll, setApplyToAll] = useState(false);
  const [tableCount, setTablecount] = useState([
    {
      capacity: 2,
      count: 0,
    },
    {
      capacity: 4,
      count: 0,
    },
    {
      capacity: 6,
      count: 0,
    },
    {
      capacity: 8,
      count: 0,
    },
  ]);
  const [errors, setErrors] = useState({});
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [selectedAmenities, setSelectedAmenities] = useState([]);
  const [amenityList, setAmenityList] = useState([]);
  const { showToast } = useToastContext();
  const { requestConfirmation } = useUserContext();
  const { setLoading } = useLoaderContext();
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [downTimeHistory, setDownTimeHistory] = useState([]);
  const [showDowntimeHistory, setShowDowntimeHistory] = useState(false);
  const [downTimeData, setDownTimeData] = useState({});
  const [downTimeBookingData, setDownTimeBookingData] = useState({
    totalBookingCount: "",
    totalAfterDiscount: "",
  });
  const [isTodayDown, setIsTodayDown] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [downTimeEditData, setDownTimeEditData] = useState({});
  const [editingDowntime, setEditingDowntime] = useState(null);
  const [editDowntimeForm, setEditDowntimeForm] = useState({
    startDate: null,
    endDate: null,
    downtimeReason: "",
  });
  // const downTimeBookingData =;

  const fetchDropdown = async () => {
    try {
      setLoading(true);

      const response = await apiGet(dropdownRestaurantExtraDetails);
      if (response?.success) {
        setAmenityList(response.data?.amenityList || []);
      } else {
        showToast(response?.message || "Something went wrong!", "error");
      }
    } catch (error) {
      showToast(
        error?.response?.message || error?.message || "Something went wrong!",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleTimeChange = (newValue, type, day) => {
    const formattedTime = newValue ? dayjs(newValue).format("HH:mm") : "";

    const updatedTimings = {
      ...formData.serviceTimings,
      [day]: {
        ...formData.serviceTimings[day],
        [type]: formattedTime,
      },
    };

    // Apply to all if toggle is active and day is Monday
    if (applyToAll && day === "Monday") {
      Object.keys(updatedTimings).forEach((d) => {
        if (d !== "Monday") {
          updatedTimings[d] = {
            ...updatedTimings[d],
            openingTime: updatedTimings["Monday"].openingTime,
            closingTime: updatedTimings["Monday"].closingTime,
          };
        }
      });
    }

    setFormData((prev) => ({
      ...prev,
      serviceTimings: updatedTimings,
    }));
  };

  const handleApplyToAllToggle = (e) => {
    const checked = e.target.checked;
    setApplyToAll(checked);

    const mondayTiming = formData.serviceTimings["Monday"];
    const updatedTimings = { ...formData.serviceTimings };

    Object.keys(updatedTimings).forEach((day) => {
      if (day !== "Monday") {
        updatedTimings[day] = checked
          ? {
              ...updatedTimings[day],
              openingTime: mondayTiming?.openingTime || "",
              closingTime: mondayTiming?.closingTime || "",
            }
          : {
              ...updatedTimings[day],
              openingTime: "",
              closingTime: "",
            };
      }
    });

    setFormData((prev) => ({
      ...prev,
      serviceTimings: updatedTimings,
    }));
  };

  const handleDatePickerChange = (newValue, field) => {
    if (dayjs(newValue).isValid()) {
      setFormData((prev) => ({
        ...prev,
        [field]: dayjs(newValue).toISOString(),
      }));

      setErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [field]: "",
      }));

      setErrors((prev) => ({
        ...prev,
        [field]: "Invalid date format",
      }));
    }
  };

  const handleInputChange = (e, index, fieldName) => {
    const { name, value, checked, type } = e.target;
    if (["tableType", "noOfTables"].includes(fieldName)) {
      const tableEntries = [...formData.tableEntries];
      tableEntries[index][fieldName] = value;
      setFormData((prevState) => ({ ...prevState, tableEntries }));
    }
    if (type === "checkbox") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: checked,
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
    validateForm();
  };

  const handleDayToggle = (e, day) => {
    const updatedTimings = {
      ...formData.serviceTimings,
      [day]: {
        ...formData.serviceTimings[day],
        disabled: e.target.checked,
      },
    };

    setFormData((prev) => ({
      ...prev,
      serviceTimings: updatedTimings,
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    //  Price for Two
    if (
      !formData.priceForTwo ||
      isNaN(formData.priceForTwo) ||
      Number(formData.priceForTwo) <= 0
    ) {
      newErrors.priceForTwo =
        "Please enter a valid price for two greater than 0.";
      isValid = false;
    }

    if (!formData?.bookingBeforeHours) {
      newErrors.bookingBeforeHours =
        "Please select earliest advance booking hours.";
      isValid = false;
    }

    //  Camera Details (max 200 characters)
    if (formData.cameraDetails && formData.cameraDetails.length > 100) {
      newErrors.cameraDetails =
        "Camera details should not exceed 100 characters.";
      isValid = false;
    }

    //  Guidelines Details (max 200 characters)
    if (!formData.cancellationPolicyDetails?.trim()) {
      newErrors.cancellationPolicyDetails =
        "Please enter restaurant guidelines.";
      isValid = false;
    } else if (formData.cancellationPolicyDetails.length > 200) {
      newErrors.cancellationPolicyDetails =
        "Guidelines details should not exceed 200 characters.";
      isValid = false;
    }

    //  Cancellation Allowed befor hours
    if (formData.cancellationPolicy && !formData.cancellationBeforeHours) {
      newErrors.cancellationBeforeHours =
        "Please select cancellation time in hours.";
      isValid = false;
    }

    // Amenities Validation
    if (!selectedAmenities.length) {
      newErrors.amenities = "Please select at least one amenity.";
      isValid = false;
    } else if (selectedAmenities.length > 10) {
      newErrors.amenities = "You can select up to 10 amenities only.";
      isValid = false;
    }

    //  Service Timings (no empty opening/closing times)
    const daysOfWeek = Object.keys(formData.serviceTimings);
    for (const day of daysOfWeek) {
      const { openingTime, closingTime } = formData.serviceTimings[day];
      if (!openingTime || !closingTime) {
        newErrors.serviceTimings =
          "Please provide both opening and closing times for all days.";
        isValid = false;
        break;
      }
    }

    // Conditional date validation
    const hasStartDate = !!formData.startDate;
    const hasEndDate = !!formData.endDate;
    const hasDowntimeReason = !!formData.downtimeReason;

    // If start date is provided, then end date and reason become required
    if (hasStartDate) {
      if (!hasEndDate) {
        newErrors.endDate = "End date is required when start date is provided";
        isValid = false;
      }

      if (!hasDowntimeReason) {
        newErrors.downtimeReason = "Downtime reason is required.";
        isValid = false;
      }
    }

    const today = dayjs().startOf("day");

    // Start Date Validation
    if (hasStartDate) {
      const start = dayjs(formData.startDate);

      if (start.isBefore(today, "day")) {
        newErrors.startDate = "Start date cannot be in the past";
        isValid = false;
      }
    }

    // End Date Validation
    if (hasEndDate) {
      const end = dayjs(formData.endDate);

      if (end.isBefore(today)) {
        newErrors.endDate = "End date cannot be in the past";
        isValid = false;
      }

      if (!hasStartDate) {
        newErrors.startDate =
          "Start date is required when end date is provided";
        isValid = false;
      } else {
        const start = dayjs(formData.startDate);
        if (end.isBefore(start)) {
          newErrors.endDate = "End date cannot be before start date";
          isValid = false;
        }
      }
    }

    // Downtime reason length validation (only if reason exists)
    if (hasDowntimeReason && formData.downtimeReason.length > 100) {
      newErrors.downtimeReason =
        "Downtime reason should not exceed 100 characters";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  useEffect(() => {
    const isValid = validateForm();
    setIsButtonDisabled(!isValid);
  }, [formData]);

  const getExtraDetails = async () => {
    try {
      setLoading(true);

      const response = await apiGet(`${dropdownExtraDetails}/${restaurantID}`);
      if (response.success) {
        const responseData = response.data;
        setDownTimeHistory(response?.restaurantDownTime);
        const isTodayDown = response.restaurantDownTime?.some((dt) => {
          const now = new Date();
          const start = new Date(dt.startDate);
          const end = new Date(dt.endDate);

          return now >= start && now <= end;
        });
        setIsTodayDown(isTodayDown);
        setFormData({
          cameraStatus: responseData?.isCameraIntalled || false,
          cameraDetails: responseData?.cameraDetails || "",
          maxOccupancy: responseData?.maxOccupancy || "",
          priceForTwo: responseData?.priceForTwo || "",
          // serviceDays: responseData?.serviceDays || [],
          serviceTimings: {
            Monday: responseData?.serviceTimings?.Monday || {
              openingTime: "",
              closingTime: "",
            },
            Tuesday: responseData?.serviceTimings?.Tuesday || {
              openingTime: "",
              closingTime: "",
            },
            Wednesday: responseData?.serviceTimings?.Wednesday || {
              openingTime: "",
              closingTime: "",
            },
            Thursday: responseData?.serviceTimings?.Thursday || {
              openingTime: "",
              closingTime: "",
            },
            Friday: responseData?.serviceTimings?.Friday || {
              openingTime: "",
              closingTime: "",
            },
            Saturday: responseData?.serviceTimings?.Saturday || {
              openingTime: "",
              closingTime: "",
            },
            Sunday: responseData?.serviceTimings?.Sunday || {
              openingTime: "",
              closingTime: "",
            },
          },
          startDate: null,
          endDate: null,
          downtimeReason: "",
          amenities: responseData?.amenities || [],
          cancellationBeforeHours: responseData?.cancellationBeforeHours || "",
          cancellationPolicy: responseData?.cancellationPolicy || false,
          cancellationPolicyDetails:
            responseData?.cancellationPolicyDetails || "",
          tableEntries: responseData?.tables ? responseData?.tables : [],
          bookingBeforeHours: responseData?.bookingBeforeHours || 0,
        });
        const amenityList = responseData?.amenities
          ? responseData?.amenities?.map((data, index) => ({
              _id: index,
              amenityName: data,
            }))
          : [];
        setSelectedAmenities(amenityList);
        setTablecount(
          responseData?.tables && responseData?.tables.length > 0
            ? responseData?.tables
            : [
                {
                  capacity: 2,
                  count: 0,
                },
                {
                  capacity: 4,
                  count: 0,
                },
                {
                  capacity: 6,
                  count: 0,
                },
                {
                  capacity: 8,
                  count: 0,
                },
              ]
        );
        setMaxOccupancy(responseData?.maxOccupancy || 0);
      } else {
        showToast(
          response?.Addmessage || "An error occurred. Please try again.",
          "error"
        );
      }
    } catch (error) {
      showToast(
        error?.response?.message ||
          error?.message ||
          "An error occurred. Please try again.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const updateDownTime = async () => {
    try {
      // const response = await apiPut(`${restaurantDownTime}/${restaurantID}`, data)
      // if(response.success){
      //   showToast("Down time updated successfully.", "success");
      // }else{
      //   showToast(response.message || "An error occurred. Please try again.", "error");
      // }
    } catch (error) {
      showToast(
        error?.response?.message ||
          error?.message ||
          "An error occurred. Please try again.",
        "error"
      );
    }
  };

  const removeDownTime = async () => {
    try {
      const response = await apiDelete(`${restaurantDownTime}/${restaurantID}`);
      if (response.success) {
        showToast("Down time removed successfully.", "success");
      } else {
        showToast(
          response.message || "An error occurred. Please try again.",
          "error"
        );
      }
    } catch (error) {
      showToast(
        error?.response?.message ||
          error?.message ||
          "An error occurred. Please try again.",
        "error"
      );
    }
  };

  const handleEditDowntime = (downtime) => {
    setEditingDowntime(downtime);
    setEditDowntimeForm({
      startDate: dayjs(downtime.startDate),
      endDate: dayjs(downtime.endDate),
      downtimeReason: downtime.downtimeReason || "",
    });
  };

  const handleDeleteDowntime = async (downtime) => {
    const result = await requestConfirmation(
      "Are you sure you want to delete this downtime?"
    );
    if (!result) return;

    try {
      setLoading(true);
      const response = await apiDelete(`${restaurantDownTime}/${downtime._id}`);
      if (response.success) {
        showToast("Downtime deleted successfully.", "success");
        getExtraDetails(); // Refresh the data
      } else {
        showToast(
          response.message || "An error occurred. Please try again.",
          "error"
        );
      }
    } catch (error) {
      showToast(
        error?.response?.message ||
          error?.message ||
          "An error occurred. Please try again.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSaveEditDowntime = async () => {
    if (
      !editDowntimeForm.startDate ||
      !editDowntimeForm.endDate ||
      !editDowntimeForm.downtimeReason
    ) {
      showToast("Please fill all the fields", "error");
      return;
    }

    try {
      setLoading(true);
      let msg = "Want to update downtime for this restaurant ?";
      if (downTimeBookingData?.totalBookingCount) {
        msg = `Want to cancel ${downTimeBookingData?.totalBookingCount} bookings and update downtime ? `;
      }

      const result = await requestConfirmation(msg);
      if (!result) return;
      const data = {
        startDate: editDowntimeForm.startDate.toISOString(),
        endDate: editDowntimeForm.endDate.toISOString(),
        downtimeReason: editDowntimeForm.downtimeReason,
      };

      const response = await apiPut(
        `${restaurantDownTime}/${editingDowntime._id}`,
        data
      );
      if (response.success) {
        showToast("Downtime updated successfully.", "success");
        setEditingDowntime(null);
        setEditDowntimeForm({
          startDate: null,
          endDate: null,
          downtimeReason: "",
        });
        getExtraDetails(); // Refresh the data
      } else {
        showToast(
          response.message || "An error occurred. Please try again.",
          "error"
        );
      }
    } catch (error) {
      showToast(
        error?.response?.message ||
          error?.message ||
          "An error occurred. Please try again.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCancelEdit = () => {
    setEditingDowntime(null);
    setEditDowntimeForm({
      startDate: null,
      endDate: null,
      downtimeReason: "",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await requestConfirmation(
      "Want to save these details and move ahead ?"
    );
    if (!result) return;

    try {
      setLoading(true);
      formData.tableEntries = tableCount;
      formData.amenities = selectedAmenities.map(
        (amenity) => amenity.amenityName
      );

      const response = await apiPut(
        `${handleSubmitExtraDetails}/${restaurantID}`,
        formData
      );
      if (response.success) {
        showToast("Restaurant details updated successfully.", "success");
        next(restaurantID);
      } else {
        showToast(
          response.message || "An error occurred. Please try again.",
          "error"
        );
      }
    } catch (error) {
      showToast(
        error?.response?.message || "An error occurred. Please try again.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const currentSettlementData = {};
  const handleDecrease = (capacity) => {
    const data = [...tableCount];
    data.forEach((item) => {
      if (item.capacity === capacity && item.count > 0) {
        setMaxOccupancy(maxOccupancy - capacity);
        item.count--;
      }
    });
    setTablecount(data);
  };

  const handleIncrease = (capacity) => {
    const data = [...tableCount];
    data.forEach((item) => {
      if (item.capacity === capacity) {
        setMaxOccupancy(maxOccupancy + capacity);
        item.count++;
      }
    });
    setTablecount(data);
  };

  const handleSelectAmenity = (event, newValue) => {
    const seen = new Set();
    const formattedAmenities = [];

    newValue.forEach((amenity) => {
      const amenityObj =
        typeof amenity === "string" ? { amenityName: amenity } : amenity;

      const key = amenityObj.amenityName?.toLowerCase();

      if (!seen.has(key)) {
        seen.add(key);
        formattedAmenities.push(amenityObj);
      }
    });

    setSelectedAmenities(formattedAmenities);
  };

  const checkDownTimeBookings = async () => {
    try {
      setLoading(true);
      const startDate = new Date(formData.startDate);
      startDate.setHours(0, 0, 0, 0); // Sets time to 00:00:00.000

      const endDate = new Date(formData.endDate);
      endDate.setHours(23, 59, 59, 999); // Sets time to 23:59:59.999

      const data = {
        startDate,
        endDate,
        downtimeReason: formData?.downtimeReason,
      };
      const response = await apiPut(
        `${checkRestaurantDownTimeBookings}/${restaurantID}`,
        data
      );
      if (response?.success) {
        setDownTimeBookingData(response?.data);
      } else {
        showToast(
          response?.message || "An error occurred. Please try again.",
          "error"
        );
      }
    } catch (error) {
      showToast(
        error?.response?.message ||
          error?.message ||
          "An error occurred. Please try again.",
        "error"
      );
    } finally {
      setLoading(false);
    }
    setHasSearched(true);
  };

  const cancelBookingAndUpdateDownTime = async () => {
    try {
      if (
        !formData.startDate ||
        !formData.endDate ||
        !formData.downtimeReason
      ) {
        showToast("Please fill all the fields", "error");
        return;
      }

      let msg = "Want to update downtime for this restaurant ?";
      if (downTimeBookingData?.totalBookingCount) {
        msg = `Want to cancel ${downTimeBookingData?.totalBookingCount} bookings and update downtime ?`;
      }

      const result = await requestConfirmation(msg);
      if (!result) return;

      setLoading(true);

      const startDate = new Date(formData.startDate);
      startDate.setHours(0, 0, 0, 0);

      const endDate = new Date(formData.endDate);
      endDate.setHours(23, 59, 59, 999);

      const data = {
        startDate,
        endDate,
        downtimeReason: formData?.downtimeReason,
      };

      const response = await apiPost(
        `${restaurantDownTime}/${restaurantID}`,
        data
      );

      if (response.success) {
        showToast(
          response.message || "DownTime Added Successfully!",
          "success"
        );

        // ✅ Clear all input fields
        setFormData({
          startDate: null,
          endDate: null,
          downtimeReason: "",
        });

        // ✅ Clear errors and other state
        setErrors({});
        setHasSearched(false);
        setDownTimeBookingData(null);
      } else {
        showToast(
          response?.message || "An error occurred. Please try again.",
          "error"
        );
      }
    } catch (error) {
      showToast(
        error?.response?.message ||
          error?.message ||
          "An error occurred. Please try again.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleTableCountChange = () => {};

  useEffect(() => {
    if (restaurantID) {
      getExtraDetails();
    }
  }, [restaurantID]);

  useEffect(() => {
    fetchDropdown();
  }, []);

  useEffect(() => {
    const isValid = validateForm();
    setIsButtonDisabled(!isValid);
  }, [formData, selectedAmenities]);

  return (
    <Box className={styles.mainProfilePage}>
      <Helmet>
        <title>Register Restaurant | DiNEST</title>
        <meta name="description" content="Register restaurant on DiNEST" />
      </Helmet>
      <Box className={styles.mainContainer}>
        <Typography variant="h4" className={styles.containerTitle}>
          Restaurant Extra Details
        </Typography>

        {/* Camera Installation Status Section */}
        <SectionPaper className={styles.sectionColor}>
          <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
            Camera Installation Status
          </Typography>

          <Grid container spacing={2}>
            <Grid>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.cameraStatus}
                    onChange={(e) => handleInputChange(e, "cameraStatus")}
                    name="cameraStatus"
                  />
                }
                label="Camera installed if any ?"
              />
            </Grid>
          </Grid>

          {formData.cameraStatus && (
            <Grid>
              <TextField
                className={styles.textAreaInput}
                label="Installation details"
                name="cameraDetails"
                fullWidth
                value={formData.cameraDetails}
                onChange={(e) => handleInputChange(e, "cameraDetails")}
                multiline
                rows={5}
              />
              {errors.cameraDetails && (
                <p className={styles.error} style={{ minHeight: "1.5rem" }}>
                  {errors.cameraDetails}
                </p>
              )}
            </Grid>
          )}
        </SectionPaper>

        {/* Max Occupancy Section */}
        <SectionPaper className={styles.sectionColor}>
          <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
            Average Price for Restaurant
          </Typography>

          <Grid container spacing={2}>
            <Grid className={styles.gridInput}>
              <TextField
                label="Average price for two persons in ₹"
                name="priceForTwo"
                fullWidth
                className={styles.inputTextfield}
                value={formData.priceForTwo}
                onChange={(e) => handleInputChange(e, "priceForTwo")}
                type="number"
                InputProps={{
                  inputProps: { inputMode: "numeric", pattern: "[0-9]*" },
                  classes: { input: styles.noArrows },
                }}
              />
              {errors.priceForTwo && (
                <p className={styles.error} style={{ minHeight: "1.5rem" }}>
                  {errors.priceForTwo}
                </p>
              )}
            </Grid>
          </Grid>
        </SectionPaper>

        {/* Timings Section */}
        <SectionPaper className={styles.sectionColor}>
          <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
            Restaurant Timings
          </Typography>

          <Grid container spacing={2}>
            {Object.keys(formData.serviceTimings).map(
              (day, index, daysArray) => (
                <Grid
                  container
                  spacing={2}
                  key={day}
                  className={styles.dayContainer}
                >
                  {/* Day Label */}
                  <Grid size={{ xs: 12 }} className={styles.dayLabel}>
                    <Typography variant="h6" align="left">
                      {day}
                    </Typography>
                    <FormControlLabel
                      sx={{ ml: 2 }}
                      control={
                        <Switch
                          checked={formData.serviceTimings[day]?.disabled}
                          onChange={(e) => handleDayToggle(e, day)}
                        />
                      }
                      label="Closed"
                    />
                  </Grid>

                  {/* Opening and Closing Time Fields */}
                  <Grid spacing={2}>
                    <Grid className={styles.gridDateInput}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <TimePicker
                          label="Opening time"
                          disabled={formData?.serviceTimings[day]?.disabled}
                          className={styles.gridDropdownInputbox}
                          value={
                            formData.serviceTimings[day]?.openingTime
                              ? dayjs(
                                  formData.serviceTimings[day].openingTime,
                                  "HH:mm"
                                )
                              : null
                          }
                          onChange={(newValue) =>
                            handleTimeChange(newValue, "openingTime", day)
                          }
                          renderInput={(params) => (
                            <TextField {...params} fullWidth />
                          )}
                        />
                      </LocalizationProvider>

                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <TimePicker
                          label="Closing time"
                          disabled={formData.serviceTimings[day]?.disabled}
                          className={styles.gridDropdownInputbox}
                          value={
                            formData.serviceTimings[day]?.closingTime
                              ? dayjs(
                                  formData.serviceTimings[day].closingTime,
                                  "HH:mm"
                                )
                              : null
                          }
                          onChange={(newValue) =>
                            handleTimeChange(newValue, "closingTime", day)
                          }
                          renderInput={(params) => (
                            <TextField {...params} fullWidth />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>

                  {/* Insert the switch right after Monday */}
                  {day === "Monday" && (
                    <Grid size={{ xs: 12 }}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={applyToAll}
                            onChange={handleApplyToAllToggle}
                            disabled={
                              !formData.serviceTimings["Monday"]?.openingTime ||
                              !formData.serviceTimings["Monday"]?.closingTime
                            }
                          />
                        }
                        label="Apply monday’s timings to all days"
                      />
                    </Grid>
                  )}
                </Grid>
              )
            )}
          </Grid>
          {errors.serviceTimings && (
            <p className={styles.error} style={{ minHeight: "1.5rem" }}>
              {errors.serviceTimings}
            </p>
          )}
        </SectionPaper>

        <SectionPaper className={styles.sectionColor}>
          {/* Restaurant Closure Period Section */}
          <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
            {`Temporary Closure Period    ${
              isTodayDown ? "(Closed Today)" : ""
            }`}
          </Typography>

          <Grid container spacing={2} sx={{ mt: 2, mb: 2 }}>
            <Grid className={styles.closureInputbox}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Grid className={styles.gridInput}>
                  <DatePicker
                    label="Closure start date"
                    format="DD/MM/YYYY"
                    className={styles.gridDropdownInputbox}
                    value={
                      formData.startDate ? dayjs(formData.startDate) : null
                    }
                    onChange={(newValue) =>
                      handleDatePickerChange(newValue, "startDate")
                    }
                    renderInput={(params) => (
                      <TextField {...params} fullWidth />
                    )}
                  />
                  {errors.startDate && (
                    <p className={styles.error} style={{ minHeight: "1.5rem" }}>
                      {errors.startDate}
                    </p>
                  )}
                </Grid>
              </LocalizationProvider>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Grid className={styles.gridInput}>
                  <DatePicker
                    label="Closure end date"
                    format="DD/MM/YYYY"
                    className={styles.gridDropdownInputbox}
                    value={formData.endDate ? dayjs(formData.endDate) : null}
                    onChange={(newValue) =>
                      handleDatePickerChange(newValue, "endDate")
                    }
                    minDate={
                      formData.startDate ? dayjs(formData.startDate) : null
                    }
                    renderInput={(params) => (
                      <TextField {...params} fullWidth />
                    )}
                  />
                  {errors.endDate && (
                    <p className={styles.error} style={{ minHeight: "1.5rem" }}>
                      {errors.endDate}
                    </p>
                  )}
                </Grid>
              </LocalizationProvider>
            </Grid>
          </Grid>

          {/* Downtime Reason Textarea */}
          <Grid size={{ xs: 12 }}>
            <TextField
              label="Reason for temporary closure"
              name="downtimeReason"
              value={formData.downtimeReason || ""}
              onChange={handleInputChange}
              multiline
              rows={3}
              fullWidth
              className={styles.textAreaInput}
            />
            {errors.downtimeReason && (
              <p className={styles.error} style={{ minHeight: "1.5rem" }}>
                {errors.downtimeReason}
              </p>
            )}
          </Grid>

          <Box display="flex" gap={2} mt={2.5}>
            <Button
              disabled={!formData.startDate || !formData.endDate}
              onClick={checkDownTimeBookings}
              variant="outlined"
            >
              View Bookings in Selected Date
            </Button>

            <Button
              variant="outlined"
              onClick={() => setShowDowntimeHistory(true)}
            >
              Show Downtime History
            </Button>
          </Box>

          {hasSearched &&
            (downTimeBookingData?.totalBookingCount ? (
              <Box display="flex" gap={4} mt={1} alignItems="center">
                <h5>Total Bookings: {downTimeBookingData.totalBookingCount}</h5>
                <h5>
                  Total Amount: ₹
                  {downTimeBookingData.totalAfterDiscount || "N/A"}/-
                </h5>
              </Box>
            ) : (
              <p className={styles.error}>
                No bookings found in the selected date
              </p>
            ))}

          <Button
            sx={{ backgroundColor: "#207d46", mt: 2 }}
            onClick={cancelBookingAndUpdateDownTime}
            variant="contained"
          >
            Save
          </Button>
        </SectionPaper>

        <SectionPaper className={styles.sectionColor}>
          <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
            Earliest Advance Booking{" "}
          </Typography>

          <Grid container spacing={2} direction="column">
            <Grid className={styles.cancelHoursInputBox}>
              <Dropdown
                label="Earliest advance booking (hours)"
                value={formData.bookingBeforeHours}
                onChange={(e) => handleInputChange(e, "bookingBeforeHours")}
                name="bookingBeforeHours"
                options={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((value) => {
                  return { label: `${value} hrs`, value };
                })}
              ></Dropdown>
              {errors.bookingBeforeHours && (
                <p className={styles.error} style={{ minHeight: "1.5rem" }}>
                  {errors.bookingBeforeHours}
                </p>
              )}
            </Grid>
          </Grid>
        </SectionPaper>

        {/* Advance Cancellation Section (Optional) */}
        <SectionPaper className={styles.sectionColor}>
          <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
            Advance Cancellation/Reschedule Hours
          </Typography>

          <Grid container spacing={2}>
            <Grid>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.cancellationPolicy}
                    onChange={(e) => handleInputChange(e, "cancellationPolicy")}
                    name="cancellationPolicy"
                  />
                }
                label="Enable cancellation/reshcedule hours?"
              />
            </Grid>
          </Grid>

          {formData.cancellationPolicy && (
            <Grid container spacing={2} direction="column">
              <Grid className={styles.cancelHoursInputBox}>
                <Dropdown
                  label="Cancellation/rescheduling allowed before (hours)"
                  value={formData.cancellationBeforeHours}
                  onChange={(e) =>
                    handleInputChange(e, "cancellationBeforeHours")
                  }
                  name="cancellationBeforeHours"
                  options={[4, 6, 8, 10, 12, 24].map((value) => ({
                    label: `${value} hrs`,
                    value,
                  }))}
                />
                {errors.cancellationBeforeHours && (
                  <p className={styles.error} style={{ minHeight: "1.5rem" }}>
                    {errors.cancellationBeforeHours}
                  </p>
                )}
              </Grid>
            </Grid>
          )}
        </SectionPaper>

        {/* Restaurant Guidelines Section (Mandatory) */}
        <SectionPaper className={styles.sectionColor}>
          <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
            Restaurant Guidelines
          </Typography>

          <Grid item>
            <TextField
              className={styles.textAreaInput}
              label="Restaurant Guidelines"
              name="cancellationPolicyDetails"
              fullWidth
              value={formData.cancellationPolicyDetails}
              onChange={(e) =>
                handleInputChange(e, "cancellationPolicyDetails")
              }
              multiline
              rows={5}
              required
            />
            {errors.cancellationPolicyDetails && (
              <p className={styles.error} style={{ minHeight: "1.5rem" }}>
                {errors.cancellationPolicyDetails}
              </p>
            )}
          </Grid>
        </SectionPaper>

        {/* Amenities */}
        <SectionPaper className={styles.sectionColor}>
          <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
            Amenities
          </Typography>

          <Grid
            container
            spacing={2}
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <Grid className={styles.gridInputAmenities}>
              <Autocomplete
                multiple
                freeSolo
                id="amenities-outlined"
                options={amenityList}
                className={styles.tagInputbox}
                getOptionLabel={(option) => option?.amenityName || option}
                value={selectedAmenities}
                onChange={handleSelectAmenity}
                filterSelectedOptions
                renderTags={(value, getTagProps) => {
                  const visibleTags = value.slice(0, 2);
                  const extraCount = value.length - visibleTags.length;

                  return (
                    <>
                      {visibleTags.map((option, index) => (
                        <Chip
                          key={option.amenityName || option}
                          label={option.amenityName || option}
                          {...getTagProps({ index })}
                          onClick={() => {}}
                          style={{ cursor: "default" }}
                        />
                      ))}
                      {extraCount > 0 && (
                        <Chip
                          label={`+${extraCount} more`}
                          onClick={(e) => {
                            setAnchorEl(e.currentTarget);
                            setPopoverOpen(true);
                          }}
                          style={{ cursor: "pointer" }}
                        />
                      )}
                    </>
                  );
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Amenities" />
                )}
              />
            </Grid>
          </Grid>
          {errors.amenities && (
            <p className={styles.error} style={{ minHeight: "1.5rem" }}>
              {errors.amenities}
            </p>
          )}
          <Popover
            open={popoverOpen}
            anchorEl={anchorEl}
            onClose={() => setPopoverOpen(false)}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
          >
            <Box sx={{ p: 2, maxWidth: 300 }}>
              <Typography variant="subtitle1" gutterBottom>
                Selected Amenities
              </Typography>
              {selectedAmenities.map((amenity, index) => (
                <Chip
                  key={amenity.amenityName || amenity}
                  label={amenity.amenityName || amenity}
                  onDelete={() => {
                    const updated = [...selectedAmenities];
                    updated.splice(index, 1);
                    handleSelectAmenity(null, updated);
                    if (updated.length <= 2) setPopoverOpen(false);
                  }}
                  sx={{ m: 0.5 }}
                />
              ))}
            </Box>
          </Popover>
        </SectionPaper>

        <SectionPaper className={styles.sectionColor}>
          <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
            Table Registrations
          </Typography>
          <Grid container spacing={2}>
            {tableTypes?.map((data, index) => (
              <Grid key={index} className={styles.cardGridContainer}>
                <Card className={styles.tableCard}>
                  <CardMedia
                    component="img"
                    image={data?.image}
                    alt={`${data?.capacity} Seater`}
                    height="120"
                    sx={{ objectFit: "contain" }}
                  />
                  <CardContent>
                    <Typography variant="h6" align="center">
                      {`${data?.capacity} Seater`}
                    </Typography>
                    <div className={styles.tableCountContainer}>
                      <IconButton
                        className={styles.iconBtn}
                        onClick={() => handleDecrease(data?.capacity)}
                      >
                        <Remove sx={{ fontSize: "20px" }} />
                      </IconButton>
                      <TextField
                        value={tableCount[index]?.count}
                        onChange={(e) => handleTableCountChange(e, index)}
                        size="small"
                        className={styles.textInputCounterBox}
                        inputProps={{
                          min: 1,
                          max: 10,
                          style: {
                            textAlign: "center",
                            padding: "5px",
                          },
                        }}
                      />
                      <IconButton
                        className={styles.iconBtn}
                        onClick={() => handleIncrease(data?.capacity)}
                      >
                        <Add sx={{ fontSize: "20px" }} />
                      </IconButton>
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>

          <Typography
            className={styles.totalOccupancyText}
            variant="h6"
            sx={{ mt: 2 }}
          >
            Total Occupancy = {maxOccupancy}
          </Typography>
        </SectionPaper>

        {/* Navigation Buttons */}
        <Box sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
          <Button
            className={styles.prevButton}
            variant="contained"
            onClick={() => prev(restaurantID)}
            sx={{ marginRight: 2, backgroundColor: "#207d46" }}
          >
            Prev
          </Button>
          <Button
            className={styles.saveButton}
            disabled={isButtonDisabled}
            variant="contained"
            color="primary"
            onClick={(e) => {
              handleSubmit(e);
            }}
            sx={{ backgroundColor: "#207d46" }}
          >
            Save & Next
          </Button>
        </Box>
      </Box>

      <Dialog fullWidth maxWidth="xs" open={showDowntimeHistory}>
        <div
          onClick={() => setShowDowntimeHistory(false)}
          className={styles.backIconContainer}
        >
          <ArrowBackIcon className={styles.backIcon} />
        </div>

        <Typography variant="h6" className={styles.titleSettlementModal}>
          Downtime History
        </Typography>

        <DialogContent className={styles.formScrollable}>
          <Box
            sx={{
              width: "80%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              alignContent: "center",
              alignSelf: "center",
              margin: "0 auto",
            }}
          >
            {downTimeHistory?.length > 0 ? (
              downTimeHistory?.map((data, index) => (
                <Box
                  key={index}
                  sx={{
                    // border: "1px solid #ccc",
                    borderRadius: 1,
                    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
                    padding: 2,
                    color:
                      data?.isDeleted || data?.isActive === false
                        ? "#fff"
                        : "black",
                    backgroundColor:
                      data?.isDeleted || data?.isActive === false
                        ? "#f44336"
                        : "#f5f5f5",
                    width: "100%",
                    overflowWrap: "break-word",
                    wordBreak: "break-word",
                    position: "relative",
                    marginY: "20px",
                  }}
                >
                  {editingDowntime?._id === data._id ? (
                    // Edit Mode
                    <Box sx={{ width: "100%" }}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} className={styles.inputGroup}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              className={styles.inputGroup}
                              label="Start Date"
                              format="DD/MM/YYYY"
                              value={editDowntimeForm.startDate}
                              onChange={(newValue) =>
                                setEditDowntimeForm((prev) => ({
                                  ...prev,
                                  startDate: newValue,
                                }))
                              }
                              renderInput={(params) => (
                                <TextField {...params} fullWidth />
                              )}
                            />
                          </LocalizationProvider>
                        </Grid>

                        <Grid item xs={12} className={styles.inputGroup}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              className={styles.inputGroup}
                              label="End Date"
                              format="DD/MM/YYYY"
                              value={editDowntimeForm.endDate}
                              onChange={(newValue) =>
                                setEditDowntimeForm((prev) => ({
                                  ...prev,
                                  endDate: newValue,
                                }))
                              }
                              minDate={editDowntimeForm.startDate}
                              renderInput={(params) => (
                                <TextField {...params} fullWidth />
                              )}
                            />
                          </LocalizationProvider>
                        </Grid>

                        <Grid item xs={12} className={styles.inputGroup}>
                          <TextField
                            label="Reason for downtime"
                            value={editDowntimeForm.downtimeReason}
                            onChange={(e) =>
                              setEditDowntimeForm((prev) => ({
                                ...prev,
                                downtimeReason: e.target.value,
                              }))
                            }
                            multiline
                            rows={3}
                            fullWidth
                          />
                        </Grid>

                        <Grid className={styles.buttonContainer}>
                          <IconButton onClick={handleCancelEdit} size="small">
                            <CloseIcon sx={{ color: "#f44336" }} />
                          </IconButton>

                          <IconButton
                            onClick={handleSaveEditDowntime}
                            size="small"
                          >
                            <CheckIcon sx={{ color: "#207d46" }} />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </Box>
                  ) : (
                    // View Mode
                    <>
                      {(data?.isDeleted || data?.isActive === false) && (
                        <Chip
                          label={data?.isDeleted ? "Deleted" : "Inactive"}
                          onClick={() => {}}
                          size="small"
                          sx={{
                            // backgroundColor: "#f44336",
                            color: "white",
                            fontSize: "0.75rem",
                            mb: 1,
                          }}
                        />
                      )}
                      <Typography>
                        <strong>Start Date:</strong>{" "}
                        {new Date(data?.startDate).toLocaleDateString("en-GB")}
                      </Typography>
                      <Typography>
                        <strong>End Date:</strong>{" "}
                        {new Date(data?.endDate).toLocaleDateString("en-GB")}
                      </Typography>
                      <Typography>
                        <strong>Reason:</strong> {data?.downtimeReason || "N/A"}
                      </Typography>

                      {/* Edit and Delete Icons */}
                      {!(data?.isDeleted || data?.isActive === false) &&
                        new Date(data?.endDate) > new Date() && (
                          <Box
                            sx={{
                              position: "relative",
                              // top: 8,
                              // right: 8,
                              display: "flex",
                              justifyContent: "center",
                              gap: 1,
                            }}
                          >
                            <IconButton
                              size="small"
                              onClick={() => handleEditDowntime(data)}
                            >
                              <EditIcon
                                fontSize="small"
                                sx={{ color: "#207d46" }}
                              />
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={() => handleDeleteDowntime(data)}
                            >
                              <DeleteIcon
                                fontSize="small"
                                sx={{ color: "#f44336" }}
                              />
                            </IconButton>
                          </Box>
                        )}
                    </>
                  )}
                </Box>
              ))
            ) : (
              <Typography sx={{ color: "red" }}>
                No downtime history found.
              </Typography>
            )}
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}

export default RestaurantExtraDetails;
